module.exports = __webpack_public_path__ + "static/44-future-of-work-the-rise-of-the-digital-workforce-83bb7bd16ee4bbed34e5d56386aaf773.png";